import * as React from 'react';

export const issueIconOutline = (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.50579 17.776L0 19L0.807988 12.8233C0.289114 11.6782 0 10.4053 0 9.06431C0 4.05823 4.02944 0 9 0C13.9706 0 18 4.05823 18 9.06431C18 14.0704 13.9706 18.1286 9 18.1286C8.13464 18.1286 7.29781 18.0056 6.50579 17.776ZM6.13854 15.796C6.4446 15.7384 6.75979 15.7536 7.059 15.8403C7.68359 16.0214 8.33459 16.1143 9 16.1143C12.866 16.1143 16 12.9579 16 9.06431C16 5.17069 12.866 2.01429 9 2.01429C5.13401 2.01429 2 5.17069 2 9.06431C2 10.0887 2.21581 11.0785 2.62749 11.9871C2.78325 12.3308 2.83986 12.7118 2.79085 13.0864L2.343 16.5101L6.13854 15.796ZM9.92453 8.49576C9.87421 8.99011 9.80713 9.49153 9.72327 10H8.28931C8.20545 9.49153 8.13627 8.99011 8.08176 8.49576C8.02725 8.00141 8 7.46822 8 6.89619V5H10V6.89619C10 7.46822 9.97484 8.00141 9.92453 8.49576ZM9.69355 12.7391C9.48925 12.913 9.25806 13 9 13C8.74194 13 8.51075 12.913 8.30645 12.7391C8.10215 12.5652 8 12.3188 8 12C8 11.6812 8.10215 11.4348 8.30645 11.2609C8.51075 11.087 8.74194 11 9 11C9.25806 11 9.48925 11.087 9.69355 11.2609C9.89785 11.4348 10 11.6812 10 12C10 12.3188 9.89785 12.5652 9.69355 12.7391Z"
    />
  </svg>
);

export const issueIcon = (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.50579 17.776L0 19L0.807988 12.8233C0.289114 11.6782 0 10.4053 0 9.06431C0 4.05823 4.02944 0 9 0C13.9706 0 18 4.05823 18 9.06431C18 14.0704 13.9706 18.1286 9 18.1286C8.13464 18.1286 7.29781 18.0056 6.50579 17.776ZM9.92453 8.49576C9.87421 8.99011 9.80713 9.49153 9.72327 10H8.28931C8.20545 9.49153 8.13627 8.99011 8.08176 8.49576C8.02725 8.00141 8 7.46822 8 6.89619V5H10V6.89619C10 7.46822 9.97484 8.00141 9.92453 8.49576ZM9.69355 12.7391C9.48925 12.913 9.25806 13 9 13C8.74194 13 8.51075 12.913 8.30645 12.7391C8.10215 12.5652 8 12.3188 8 12C8 11.6812 8.10215 11.4348 8.30645 11.2609C8.51075 11.087 8.74194 11 9 11C9.25806 11 9.48925 11.087 9.69355 11.2609C9.89785 11.4348 10 11.6812 10 12C10 12.3188 9.89785 12.5652 9.69355 12.7391Z"
    />
  </svg>
);
